import { render, staticRenderFns } from "./UserWithdrawal.vue?vue&type=template&id=8f683ed4&"
import script from "./UserWithdrawal.vue?vue&type=script&lang=js&"
export * from "./UserWithdrawal.vue?vue&type=script&lang=js&"
import style0 from "./UserWithdrawal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports